// Redux action types for Uber batch cancel resolution flow

export const DISPATCH_UBER_BATCH_RESOLVE = 'DISPATCH_UBER_BATCH_RESOLVE';
export const DISPATCH_UBER_BATCH_RESOLVED = 'DISPATCH_UBER_BATCH_RESOLVED';
export const DISPATCH_UBER_BATCH_ERROR = 'DISPATCH_UBER_BATCH_ERROR';

/**
 * Action creator for resolving a canceled Uber batch task.
 * @param {Object} task - The task to resolve
 * @param {Object} dock - The dock containing the task
 * @param {string} [deliveryId] - Optional Uber delivery_id to target a specific ESJ
 * @returns {Object} Redux action
 */
export const resolveUberBatchTask = (task, dock, deliveryId) => {
  return {
    type: DISPATCH_UBER_BATCH_RESOLVE,
    task: task,
    dock: dock,
    deliveryId: deliveryId || null,
  };
};

/**
 * Action creator for successful resolution.
 * @param {number} taskId - The ID of the resolved task
 * @param {Object} newDock - The new dock the task was moved to (optional)
 * @returns {Object} Redux action
 */
export const uberBatchTaskResolved = (taskId, newDock) => {
  return {
    type: DISPATCH_UBER_BATCH_RESOLVED,
    taskId: taskId,
    newDock: newDock,
  };
};

/**
 * Action creator for resolution error.
 * @param {number} taskId - The ID of the task
 * @param {string} error - The error message
 * @returns {Object} Redux action
 */
export const uberBatchTaskError = (taskId, error) => {
  return {
    type: DISPATCH_UBER_BATCH_ERROR,
    taskId: taskId,
    error: error,
  };
};
